import { observable, action, observe, makeObservable } from 'mobx'
import { IPersistObject, persistService } from '../../services'
import { retrieveFromWindow } from '../../utils'
import { CollectionView } from '../collections/collections.enums'
import { IProduct } from './product.interfaces'

class ProductStore {
  private readonly persistKey: keyof IPersistObject = 'collectionView'
  @observable products: IProduct[] = retrieveFromWindow('productData', [])
  @observable activeProduct: string = ''
  @observable collectionView: CollectionView = (persistService.get(this.persistKey) as CollectionView) || CollectionView.GRID

  constructor() {
    makeObservable(this)

    // Write active department to localStorage on change
    observe(this, 'collectionView', () => {
      persistService.set(this.persistKey, this.collectionView)
    })
  }

  @action
  gridView = (): void => {
    this.collectionView = CollectionView.GRID
  }

  @action
  listView = (): void => {
    this.collectionView = CollectionView.LIST
  }
}

export const productStore = new ProductStore()
